// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {ApplicationStatus} from './application-status';
import {Criteria} from './facets/criteria';
import {DigitalUserResults} from './results/digital-user-result';
import {FacetOptions} from './facets/facet-options';
import {Labels} from './facets/labels';

export const DigitalUserSearch = t.struct({
    applicationStatus: ApplicationStatus,
    criteria: Criteria,
    facetOptions: FacetOptions,
    labels: Labels,
    results: DigitalUserResults
}, {
    defaultProps: {
        applicationStatus: new ApplicationStatus({}),
        criteria: new Criteria({}),
        facetOptions: new FacetOptions({}),
        labels: new Labels({}),
        results: []
    },
    name: 'DigitalUserSearch',
    strict: true
});
